import { standard } from '../../constants';

export default {
  ...standard('CREATE', 'games'),
  ...standard('DELETE', 'games'),
  ...standard('GET', 'games'),
};



// WEBPACK FOOTER //
// ./src/modules/games/constants.js